/**
 * Interaction helpers for custom (non-native) controls.
 */
import type { KeyboardEvent } from "react";

/**
 * Click + keyboard handlers for an element acting as a custom selectable
 * control (e.g. a `role="radio"`/`role="checkbox"` card). Activates on click
 * and on Enter/Space, matching native control behaviour. Spread onto the
 * element; set `role`, `tabIndex`, and the relevant `aria-*` separately.
 */
export function selectableHandlers(onSelect: () => void) {
  return {
    onClick: onSelect,
    onKeyDown: (event: KeyboardEvent) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onSelect();
      }
    },
  };
}
